<div
  #focusTarget
  class="gc-chat-buttons bc-border-top"
  [class.narrow-mode]="!isExpandedMode"
  [@.disabled]="isExpandedMode"
  tabindex="-1"
>
  <div class="button-group">
    <button class="btn btn-light js-wrap-up-button" [disabled]="disableButtons" (click)="sendWrapUp.emit()">
      <span>{{ 'bcChatButtons.wrapUp' | translate }}</span>
    </button>
  </div>

  <div class="button-group">
    <button [disabled]="disableButtons" (click)="endChat.emit()" class="btn btn-light js-end-chat-button">
      <span>{{ 'bcChatButtons.endButton' | translate }}</span>
    </button>
    <ng-container *ngIf="!isCobrowseActive">
      <button
        *gcUserHasAllPermissions="[gcUserPermission.DirectoryUserView, gcUserPermission.RoutingQueueSearch]"
        (click)="openTransferPanel.emit()"
        [disabled]="disableButtons"
        class="btn btn-light js-transfer-button"
      >
        <span>{{ 'bcChatButtons.transferButton' | translate }}</span>
      </button>
    </ng-container>
  </div>
</div>
